
export const iceCstlConfig = (config) => {
    config.customer = 'icecstl';
    config.kiosk_topbar_logo = '/img/icecstl_logo_horizontal.png'
    config.topbar_bg_color = '#173963';
    config.kiosk_login_bg = '/img/icecstl_kiosk_login_bg.jpg';
    config.kiosk_form_button_bg_color = '#cb074d';
    config.kiosk_form_button_font_color = 'white';
    config.kiosk_form_button_border_color = '#27aae1';
    config.kiosk_form_border = '3px solid #27aae1';
    config.kiosk_form_border_color = '#27aae1';
    config.main_font = '"MottekaRegular", sans-serif';
    config.sub_font = '"UniformRoundedMedium", sans-serif';
    config.legal_notes = '';
    config.cart_toolbar_bg_color = 'white';
    config.kiosk_logout_btn_bg = '#cb074d';
    config.kiosk_logout_btn_border = '1px solid #cb074d';
    config.kiosk_logout_btn_font_color = 'white';
    config.kiosk_logout_btn_padding = '0rem 1rem';
    config.kiosk_toolbar_bg = '#173963';
    config.kiosk_toolbar_header_font_color = 'white';
    config.select_all_enabled = '#27aae1';
    config.select_all_disabled = 'rgb(148 148 148)';
    config.kiosk_form_bg_color = 'white';
    config.kiosk_form_border_color = '#27aae1';
    config.kiosk_form_header_font_color = 'black';
    config.kiosk_form_message_font_color = 'black';
    config.kiosk_modal_content_font_color = 'black';
    config.kiosk_modal_border_color = '#27aae1';
    config.kiosk_modal_button_action_bg_color = ' #cb074d';
    config.kiosk_modal_button_action_font_color = 'white';
    config.kiosk_modal_header_font_color = "black";
    config.kiosk_modal_bg_color = 'white';
    config.cart_panel_header_margin = '0.5rem 0rem 0rem 0rem !important'
}
